import React from "react"
import ReactDOM from "react-dom"
import "./index.css"
import App from "./App"
import Env from "./util/env"

Env.requestUserInfo(() =>
  ReactDOM.render(<App />, document.getElementById("root"))
)

window.addEventListener(
  "message",
  ({ data }) => {
    if (data.action === "logout") {
      Env.logout()
    }
  },
  false
)
